<template>
  <v-container>
    <v-layout align-center justify-center fill-height>
      <v-flex xs12 sm8 md6 lg5 xl4>
        <v-card>
          <v-card-title>TeamSpeak 服务器管理</v-card-title>
          <v-card-text>
            <v-form v-model="valid">
              <v-layout justify-space-between wrap>
                <v-flex xs12>
                  <v-text-field
                    label="账号"
                    v-model="form.username"
                    :rules="[rules.required]"
                    placeholder="例如 serveradmin"
                    name="username"
                    autocomplete="username"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="密码"
                    type="password"
                    v-model="form.password"
                    :rules="[rules.required]"
                    name="password"
                    autocomplete="current-password"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-checkbox
                    label="记住登录"
                    v-model="rememberLogin"
                  ></v-checkbox>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              color="primary"
              :disabled="!valid"
              @click="connect"
              :loading="loading"
            >
              <v-icon>arrow_forward</v-icon>连接
              <template #loader>
                <span>连接中…</span>
              </template>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  beforeRouteEnter(to, from, next) {
    next(async (vm) => {
      let token = vm.$store.state.query.token;

      vm.$store.commit("isLoggedOut", true);

      if (!token) return;

      vm.$socket.emit("autofillform", token, (response) => {
        if (response.host) {
          vm.form.username = response.username;
          vm.form.password = response.password;
        } else {
          vm.$store.dispatch("removeToken");

          vm.$toast.error(response);
        }
      });
    });
  },
  data() {
    return {
      panel: [true],
      valid: false,
      loading: false,
      rules: {
        required: (value) => !!value || "必填",
      },
      form: {
        username: "serveradmin",
        password: "",
      },
    };
  },
  computed: {
    rememberLogin: {
      set(value) {
        this.$store.commit("setRememberLogin", value);
      },
      get() {
        return this.$store.state.settings.rememberLogin;
      },
    },
  },
  methods: {
    connectTeamSpeak(credentials) {
      return this.$TeamSpeak.connect(credentials);
    },
    async connect() {
      this.loading = true;

      try {
        let { token } = await this.connectTeamSpeak({
          host: "127.0.0.1",
          queryport: 10011,
          protocol: "raw",
          username: this.form.username,
          password: this.form.password,
        });

        this.$store.dispatch("saveToken", token);
        this.$store.commit("isConnected", true);
        this.$store.commit("isLoggedOut", false);

        this.$router.push({ name: "servers" });
      } catch (err) {
        this.$toast.error(err);
      }

      this.loading = false;
    },
  },
};
</script>

<style>
.v-expansion-panel__header {
  padding: 0 !important;
}
</style>
